import module from 'finanzas/module.js'
import template from './template.html'

function FinancesPosicionbancariaPrestamosComponent ($q, FinancesPosicionbancariaPrestamos) {
  var $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.agregando = false
  $ctrl.agregar = agregar
  $ctrl.config = {}

  function $onInit () {
    $ctrl.promise = $q.all([
      FinancesPosicionbancariaPrestamos.get($ctrl.idEmpresa, $ctrl.idCuenta, $ctrl.config.fecha_inicial, $ctrl.config.fecha_final)
        .then(function (response) {
          $ctrl.data = response.data
        }),
    ])
    $ctrl.data = []
  }

  function agregar (data) {
    if (!$ctrl.agregando) {
      $ctrl.agregando = true
      return
    }

    $ctrl.agregando = false

    if (data) {
      $ctrl.data = $ctrl.data.concat(data)
    }
  }
}

module.component('financesPosicionbancariaPrestamos', {
  controller: FinancesPosicionbancariaPrestamosComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idCuenta: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/prestamos/component.js